import makeApiRequest from '../../../api/makeApiRequest';

const mapInvitationRequests = ({ id, attributes }) => ({ id, ...attributes });
const localStorageKey = 'patientInvitationRequests';

const InvitationRequests = {
  name: 'invitationRequests',
  state: {
    invitationRequests: [],
  },
  reducers: {
    onLoaded(state, invitationRequests) {
      const oldInvites = JSON.parse(localStorage.getItem(localStorageKey));
      const newInvites = invitationRequests.map(invite => {
        const oldInvite = oldInvites ? oldInvites.find(({ id }) => id === invite.id) : null;
        return {
          ...invite,
          seen: oldInvite ? oldInvite.seen : false,
        };
      });
      localStorage.setItem(localStorageKey, JSON.stringify(newInvites));
      return { ...state, invitationRequests: [...newInvites] };
    },
    onDeleted(state, id) {
      const invites = state.invitationRequests.filter(req => req.id !== id);
      localStorage.setItem(localStorageKey, JSON.stringify(invites));
      return {
        ...state,
        invitationRequests: invites,
      };
    },
    onAdded(state, payload) {
      const unreadInvite = { ...payload, seen: false };
      const invites = [...state.invitationRequests, { ...unreadInvite }];
      localStorage.setItem(localStorageKey, JSON.stringify(invites));
      return { ...state, invitationRequests: [...invites] };
    },
    onSeen(state) {
      const invitationRequests = [...state.invitationRequests.map(inv => ({ ...inv, seen: true }))];
      localStorage.setItem(localStorageKey, JSON.stringify(invitationRequests));
      return { ...state, invitationRequests };
    },
  },
  messageListeners: {
    PATIENT_INVITATION_REQUEST_DELETED({ payload }) {
      this.onDeleted(payload.id);
    },
    PATIENT_INVITATION_REQUEST_CREATED({ payload }) {
      this.onAdded(payload);
    },
  },
  effects: {
    async load(_, { oidcSession }) {
      const url = '/patient-invitation-requests';
      const [request] = makeApiRequest({ url, method: 'get' }, oidcSession);
      const { error, data } = await request;
      if (!error) {
        this.onLoaded(data.data.map(snippet => mapInvitationRequests(snippet)));
      }
    },
    async invite({ id }, { oidcSession }) {
      const url = `/patient-invitation-requests/${id}`;
      const [request] = makeApiRequest({ url, method: 'patch' }, oidcSession);
      const { error, data } = await request;
      if (!error) {
        this.onDeleted(id);
        return data;
      }
      throw error;
    },
    async delete({ id }, { oidcSession }) {
      const url = `/patient-invitation-requests/${id}`;
      const [request] = makeApiRequest({ url, method: 'delete' }, oidcSession);
      const { error } = await request;
      if (!error) {
        this.onDeleted(id);
      } else throw error;
    },
  },
};

export default InvitationRequests;
